module.exports = __webpack_public_path__ + "img/decentraland logo 1.3569905e.png";